export default "__VITE_ASSET__Cva$_vxx__"